import AddIcon from '@material-ui/icons/AddCircleRounded';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  deleteImage,
  getGetPSU,
  getPutPSU,
  putMinio,
} from '../functions/images';
import compressImage from '../utils/compress';
import { Context } from './Store';

export function TextFormField({
  label = 'Label',
  unit = '',
  value,
  setter,
  id,
  placeholder = label,
  type = 'text',
  form = '',
  required = false,
  readonly = false,
  options = [],
  numFiche = '',
  setError = () => {},
  setInfo = () => {},
  ...rest
}) {
  const [state] = useContext(Context);
  const [psu, setPsu] = useState('');

  // Fonction pour normaliser les valeurs booléennes
  const normalizeValue = (val) => {
    if (val === 'true' || val === true) return true;
    if (val === 'false' || val === false) return false;
    // Par défaut, retourner false (coche "Non")
    return false;
  };

  useEffect(() => {
    (async () => {
      if (type === 'image' && value !== '') {
        setPsu((await getGetPSU(value, state.token)).url);
      }
    })();
  }, [state.token, type, value]);

  return (
    <div className="flex flex-col text-left px-2 mb-4">
      <label htmlFor={id}>
        {`${label}`}
        {unit && <span className="italic"> ({unit})</span>}
        {required ? <span className="text-red-600"> *</span> : ''}
      </label>
      {type === 'textarea' ? (
        <textarea
          {...rest}
          rows="4"
          id={id}
          value={value}
          onChange={(e) => setter(e.target.value)}
          placeholder={`${placeholder}...`}
          title={placeholder}
          form={form}
          required={required}
          readOnly={readonly}
          className={`w-full border-2 border-stbSecond rounded pl-2 py-1 my-1 focus:outline-none focus:ring-2 focus:ring-stbSecond focus:border-gray-800 text-black h-full ${
            readonly ? 'bg-gray-400 cursor-not-allowed' : ''
          }`}
        />
      ) : type === 'radio' ? (
        <div className="flex w-full items-center justify-evenly h-full">
          <span>
            <label className="mr-3" htmlFor={`${id}-true`}>
              {options.length > 1 ? options[0]?.label : 'Oui'}
            </label>
            <input
              {...rest}
              type="radio"
              id={`${id}-true`}
              value="true"
              checked={normalizeValue(value) === true}
              onChange={() => setter(true)}
              name={id}
            />
          </span>
          <span>
            <label className="mr-3" htmlFor={`${id}-false`}>
              {options.length > 1 ? options[1]?.label : 'Non'}
            </label>
            <input
              {...rest}
              type="radio"
              id={`${id}-false`}
              value="false"
              checked={normalizeValue(value) === false}
              onChange={() => setter(false)}
              name={id}
            />
          </span>
        </div>
      ) : type === 'image' ? (
        <div>
          <div className="flex justify-center items-center mt-1 w-full border-2 border-stbSecond rounded overflow-ellipsis overflow-x-hidden text-sm bg-white">
            {!psu ? (
              <>
                <input
                  {...rest}
                  id={id}
                  type="file"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file || !file.type.startsWith('image/')) {
                      return setError('Le fichier doit être une image valide');
                    }
                    setError('');
                    setInfo("Compression de l'image en cours...");
                    try {
                      const compressedFile = await compressImage(file);
                      setInfo("Téléchargement de l'image en cours...");
                      const psu = await getPutPSU(
                        state.token,
                        `${numFiche}_${id}.${file.type.split('/')[1]}`
                      );
                      if (psu.error) {
                        setInfo('');
                        return setError(`Erreur : ${psu.error}`);
                      }
                      const upload = await putMinio(
                        psu.url,
                        compressedFile,
                        file.type
                      );
                      if (upload.error) {
                        setInfo('');
                        return setError(`Erreur : ${upload.error}`);
                      }
                      setInfo('Image téléchargée avec succès !');
                      setter(psu.name);
                    } catch (error) {
                      console.error(error);
                      setInfo('');
                      return setError(`Impossible d'utiliser la photo`);
                    }
                  }}
                  title={placeholder}
                  form={form}
                  required={required}
                  className="w-full pl-2 py-1 focus:outline-none focus:ring-2 focus:ring-stbSecond focus:border-gray-800 text-black"
                />
              </>
            ) : (
              <div
                className="text-black cursor-pointer py-1 font-normal"
                onClick={async () => {
                  if (window.confirm("Confirmez la suppression de l'image")) {
                    const deleted = await deleteImage(value, state.token);
                    if (deleted.error) return setError(deleted.error);
                    setInfo("L'image a bien été supprimée");
                    setPsu(null);
                    return setter(null);
                  }
                }}
              >
                Supprimer
                <DeleteIcon />
              </div>
            )}
          </div>
          {psu && value && (
            <img
              src={psu}
              alt="URL manquante ou erronée"
              className="italic font-thin max-h-80 object-contain my-2"
            />
          )}
        </div>
      ) : (
        <input
          {...rest}
          type={type}
          id={id}
          value={
            value === true || value === 'true'
              ? 'Oui'
              : value === false || value === 'false'
              ? 'Non'
              : value
          }
          onChange={(e) => {
            const inputValue = e.target.value;
            if (inputValue === 'Oui') {
              setter(true);
            } else if (inputValue === 'Non') {
              setter(false);
            } else {
              setter(e.target.value);
            }
          }}
          placeholder={placeholder}
          title={placeholder}
          form={form}
          required={required}
          readOnly={readonly}
          className={`w-full border-2 border-stbSecond rounded pl-2 py-1 my-1 focus:outline-none focus:ring-2 focus:ring-stbSecond focus:border-gray-800 text-black ${
            readonly ? 'bg-gray-400 cursor-not-allowed' : ''
          }`}
        />
      )}
    </div>
  );
}

export function PasswordFormField({
  value,
  setter,
  label,
  id,
  type = 'password',
  placeholder = label,
  required = false,
  readonly = false,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';

  return (
    <div className="flex flex-col text-left px-2 mb-4">
      <label htmlFor={id}>
        {label}
        {required && <span className="text-red-600"> *</span>}
      </label>
      <div className="relative">
        <input
          id={id}
          type={isPassword && showPassword ? 'text' : type}
          value={value}
          onChange={(e) => setter(e.target.value)}
          placeholder={placeholder}
          required={required}
          readOnly={readonly}
          className={`w-full border-2 border-stbSecond rounded pl-2 py-1 my-1 pr-10 focus:outline-none focus:ring-2 focus:ring-stbSecond focus:border-gray-800 text-black ${
            readonly ? 'bg-gray-400 cursor-not-allowed' : ''
          }`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2"
            tabIndex={-1}
          >
            <img
              src={showPassword ? '/eye-off.png' : '/eye.png'}
              alt={showPassword ? 'Masquer' : 'Afficher'}
              className="w-6 h-6 mt-1"
            />
          </button>
        )}
      </div>
    </div>
  );
}

export function Select({
  id,
  label,
  value,
  setter,
  multiple = false,
  locked = 0,
  options = [],
  required = false,
  inline = false,
  readonly = false,
}) {
  const clicked = (val, isChecked) => {
    if (isChecked) return setter(value.filter((v) => v !== val));
    return setter([...value, val]);
  };
  return (
    <div
      className={`flex flex-col text-left px-2 max-h-40 ${!inline && 'mb-4'}`}
    >
      <label htmlFor={id}>
        {label}
        {required ? <span className="text-red-600"> *</span> : ''}
      </label>
      {multiple ? (
        <ul className="overflow-auto text-black font-normal bg-white border-2 border-stbSecond rounded pl-2 py-1 my-1">
          {options.map((o) => {
            const isChecked =
              value.includes(o.value) ||
              value.some((v) => v?.value === o.value);
            return (
              <li key={o.value}>
                {o.value === locked ? (
                  <label className="text-stbSecond">
                    <CheckBoxIcon />
                    {o.label}
                  </label>
                ) : (
                  <label
                    htmlFor={o.value}
                    className="cursor-pointer"
                    onClick={() => clicked(o.value, isChecked)}
                  >
                    {isChecked ? (
                      <CheckBoxIcon />
                    ) : (
                      <CheckBoxOutlineBlankIcon />
                    )}
                    {o.label}
                  </label>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <select
          id={id}
          disabled={readonly}
          className={`w-full bg-white border-2 border-stbSecond rounded ${
            !inline && 'py-1 my-1 pl-2'
          } focus:outline-none focus:ring-2 focus:ring-stbSecond focus:border-gray-800 text-black ${
            readonly ? 'bg-gray-400 cursor-not-allowed' : ''
          }`}
          value={value}
          onChange={(e) => setter(e.target.value || null)}
        >
          {options.map((o) => {
            return (
              <option value={o.value} key={o.value}>
                {o.label}
              </option>
            );
          })}
        </select>
      )}
    </div>
  );
}

export function ArrayInput({
  id,
  label,
  values = [],
  setter,
  format = {},
  required = false,
  type = 'text',
  options = [],
  numFiche = '',
  setError = () => {},
  setInfo = () => {},
}) {
  const isSimple = Object.keys(format).length <= 0;
  const [newTextValue, setNewTextValue] = useState(
    isSimple ? [''] : Array(Object.keys(format).length).fill('')
  );

  const [state] = useContext(Context);
  const addRow = async () => {
    if (isSimple) {
      if (newTextValue[0] === '') return null;
      setter([...values, newTextValue[0]]);
      setNewTextValue(['']);
    } else {
      if (newTextValue.some((e) => e === '')) return null;
      const newObj = {};
      Object.keys(format).map((f, i) => (newObj[f] = newTextValue[i]));
      setter([...values, newObj]);
      setNewTextValue(Array(Object.keys(format).length).fill(''));
    }
  };
  const [deletedRows, setDeletedRows] = useState(new Set());

  const deleteRow = (i, event) => {
    // Différencier le message selon le type
    const confirmMessage =
      type === 'image'
        ? "Confirmez la suppression de l'image"
        : 'Confirmez la suppression de cette ligne';

    const isConfirmed = window.confirm(confirmMessage);

    if (isConfirmed) {
      // Logique spécifique pour les images
      if (type === 'image') {
        const imageName = values[i];
        const token = state.token;

        const imagesToDelete =
          JSON.parse(localStorage.getItem('imagesToDelete')) || [];

        const imageExists = imagesToDelete.some(
          (image) => image.imageName === imageName
        );

        if (!imageExists) {
          imagesToDelete.push({ imageName, token });
          localStorage.setItem(
            'imagesToDelete',
            JSON.stringify(imagesToDelete)
          );
        }

        setInfo("L'image a bien été supprimée");
      } else {
        // Message pour les autres types (sondes, roulements, etc.)
        setInfo('La ligne a bien été supprimée');
      }

      // Suppression de l'élément dans tous les cas
      const updatedValues = values.filter((value, index) => index !== i);
      setter(updatedValues);
    }
  };

  // Utiliser useEffect pour écouter les événements 'beforeunload' et 'popstate' pour supprimer le localStorage
  const history = useHistory();

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Supprimer 'imagesToDelete' du localStorage dès que l'utilisateur quitte la page
      localStorage.removeItem('imagesToDelete');
    };

    const handlePopState = () => {
      // Supprimer 'imagesToDelete' du localStorage dès que l'utilisateur revient en arrière
      localStorage.removeItem('imagesToDelete');
    };

    const handleNavigation = () => {
      // Supprimer 'imagesToDelete' du localStorage lors de la navigation vers une nouvelle page
      localStorage.removeItem('imagesToDelete');
    };

    // Ajouter les écouteurs d'événements pour 'beforeunload' et 'popstate'
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    // Gérer la navigation via le système de routage (si utilisant React Router)
    const unlisten = history.listen(() => {
      handleNavigation(); // Appeler la suppression lors de la navigation
    });

    // Nettoyage des écouteurs d'événements lorsque le composant est démonté
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      unlisten(); // Supprimer l'écouteur d'événements de React Router
    };
  }, [history]);

  const updateRow = (val, index, field = '') => {
    if (isSimple) {
      setter(
        values.map((f, i2) => {
          if (i2 === index) return val;
          return f;
        })
      );
    } else {
      setter(
        values.map((f, i2) => {
          if (i2 === index) {
            return { ...f, [field]: val };
          }
          return f;
        })
      );
    }
  };

  const [psus, setPsus] = useState([]);

  useEffect(() => {
    (async () => {
      if (type === 'image' && values.length > 0) {
        const imageUrls = await Promise.all(
          values.map(async (value) => (await getGetPSU(value, state.token)).url)
        );
        setPsus(imageUrls);
      }
    })();
  }, [state.token, type, values]);

  const combinedValues = values.map((value, index) => ({
    imageName: value,
    imageUrl: psus[index],
  }));

  return (
    <div
      className={`flex flex-col text-left px-2 mb-4 ${
        isSimple ? '' : 'sm:col-span-4'
      }`}
    >
      <label htmlFor={id} className="text-lg font-semibold">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div
        className="overflow-y-auto max-h-96 border border-gray-300 rounded-lg shadow-md bg-white"
        style={{ maxHeight: '300px' }}
      >
        <table className="w-full text-sm text-gray-800 bg-white">
          <thead>
            {!isSimple && (
              <tr className="bg-gray-200 text-left text-gray-600">
                {Object.keys(format).map((field, i) => (
                  <th key={i} className="px-4 py-2">
                    {format[field].label}
                  </th>
                ))}
                <th className="px-4 py-2 w-16">Actions</th>
              </tr>
            )}
          </thead>
          <tbody>
            {values.map((v, i) => {
              if (isSimple && !v) return null;
              const imageData = combinedValues[i];
              return (
                <tr key={i}>
                  {!isSimple ? (
                    <>
                      {Object.keys(format).map((field, i2) => {
                        const fieldFormat = format[field];
                        const fieldType = fieldFormat.type || 'text';

                        return (
                          <td key={i2}>
                            {fieldType === 'select' ? (
                              <select
                                className="w-full border rounded text-sm py-1 px-1 focus:ring-0"
                                value={v[field]}
                                onChange={(e) =>
                                  updateRow(e.target.value, i, field)
                                }
                              >
                                <option value="">Choisir...</option>
                                {fieldFormat.values?.map((opt) => (
                                  <option
                                    key={opt.value || opt}
                                    value={opt.value || opt}
                                  >
                                    {opt.label || opt}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <textarea
                                type={fieldType}
                                className="w-full border rounded resize-y text-sm py-1 px-1 focus:ring-0"
                                defaultValue={v[field]}
                                onChange={(e) =>
                                  updateRow(e.target.value, i, field)
                                }
                              />
                            )}
                          </td>
                        );
                      })}

                      <td className="flex justify-center items-center">
                        <div
                          className="cursor-pointer"
                          onClick={() => deleteRow(i)}
                        >
                          <DeleteIcon />
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2">
                        <div className="relative flex items-center group">
                          <div
                            className="text-sm font-medium text-gray-800 truncate"
                            style={{ maxWidth: '125px' }}
                          >
                            {imageData?.imageName || 'Nom inconnu'}
                          </div>
                          <div
                            className="absolute top-full left -ml-4 -translate-x-1/2 mt-2 opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 bg-gradient-to-r from-viguierBleu via-blue-900 to-viguierBleuClair text-white text-xs font-semibold px-2 py-2 rounded-md shadow-2xl z-10 transition-all duration-300"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {imageData?.imageName}
                          </div>
                        </div>
                      </td>

                      <td className="px-4 py-2">
                        <div className="flex items-center space-x-4">
                          {imageData?.imageUrl && (
                            <div className="relative group">
                              <img
                                src={imageData.imageUrl}
                                alt={imageData.imageName}
                                className="w-20 h-20 object-cover rounded-md border border-gray-300 shadow-md"
                              />
                              <div
                                className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                                onClick={() =>
                                  window.open(imageData.imageUrl, '_blank')
                                }
                              >
                                <VisibilityIcon className="text-white w-8 h-8 cursor-pointer" />
                              </div>
                            </div>
                          )}
                          <button
                            className="p-2 rounded-full hover:bg-red-200"
                            onClick={() => deleteRow(i, event)}
                          >
                            <DeleteIcon className="text-red-600" />
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            {!isSimple ? (
              <tr>
                {Object.keys(format).map((field, i) => {
                  const fieldFormat = format[field];
                  const fieldType = fieldFormat.type || 'text';

                  return (
                    <td key={i}>
                      {fieldType === 'select' ? (
                        <select
                          className="w-full border rounded text-sm py-1 px-1 focus:ring-0"
                          value={newTextValue[i]}
                          onChange={(e) =>
                            setNewTextValue(
                              newTextValue.map((t, i2) =>
                                i2 === i ? e.target.value : t
                              )
                            )
                          }
                        >
                          <option value="">Choisir...</option>
                          {fieldFormat.values?.map((opt) => (
                            <option
                              key={opt.value || opt}
                              value={opt.value || opt}
                            >
                              {opt.label || opt}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type={fieldType}
                          className="w-full overflow-ellipsis overflow-x-hidden text-sm py-1 px-1"
                          placeholder="Ajouter un champ..."
                          value={newTextValue[i]}
                          onChange={(e) =>
                            setNewTextValue(
                              newTextValue.map((t, i2) =>
                                i2 === i ? e.target.value : t
                              )
                            )
                          }
                        />
                      )}
                    </td>
                  );
                })}
                <td>
                  <div className="flex border-l-2 border-stbSecond justify-center items-center">
                    <AddIcon className="cursor-pointer" onClick={addRow} />
                  </div>
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={type !== 'image' ? 1 : 2}>
                  <input
                    className="w-full overflow-ellipsis overflow-x-hidden text-sm py-1 px-2"
                    placeholder={'Ajouter un champ...'}
                    type={type === 'image' ? 'file' : 'text'}
                    value={newTextValue[0]}
                    onChange={async (e) => {
                      if (type === 'image') {
                        const file = e.target.files[0];
                        if (!file || !file.type.startsWith('image/')) {
                          return setError(
                            'Le fichier doit être une image valide'
                          );
                        }
                        setError('');
                        setInfo("Compression de l'image en cours...");
                        try {
                          const compressedFile = await compressImage(file);
                          setInfo("Téléchargement de l'image en cours...");
                          const psu = await getPutPSU(
                            state.token,
                            `${numFiche}_${file.name}`
                          );
                          if (psu.error) {
                            setInfo('');
                            return setError(`Erreur : ${psu.error}`);
                          }
                          const upload = await putMinio(
                            psu.url,
                            compressedFile,
                            file.type
                          );
                          if (upload.error) {
                            setInfo('');
                            return setError(`Erreur : ${upload.error}`);
                          }
                          setInfo('Image téléchargée avec succès !');
                          setter([...values, psu.name]);
                        } catch (error) {
                          console.error(error);
                          setInfo('');
                          return setError(`Impossible d'utiliser la photo`);
                        }
                      } else {
                        setNewTextValue([e.target.value]);
                      }
                    }}
                    list={`datalist-array-${id}`}
                  />
                  {options && (
                    <datalist id={`datalist-array-${id}`}>
                      {options.map((o) => (
                        <option value={o.label} key={o.value} />
                      ))}
                    </datalist>
                  )}
                </td>
                {type !== 'image' && (
                  <td>
                    <div className="border-l-2 border-stbSecond w-full flex justify-center items-center">
                      <AddIcon className="cursor-pointer" onClick={addRow} />
                    </div>
                  </td>
                )}
              </tr>
            )}
          </tfoot>
        </table>
      </div>
    </div>
  );
}
